import styled from "styled-components";
import { FaAppStoreIos } from "react-icons/fa";
import { BsArrowUpRight } from "react-icons/bs";
import reminderbroImage from "images/optimized/apps/reminderbro.webp";
import { Image } from "components/image";
import { BrandName } from "components/brandName";

const StyledApps = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledHeader = styled.h2`
  font-family: Roboto-Black;
  color: #f0ece5;
  text-align: center;
  text-transform: uppercase;
`;

const StyledIntro = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  max-width: 620px;
  margin: 0 0 38px;
  color: #b8c1c7;
  font-family: Roboto-Light;
  font-size: 18px;
  line-height: 1.6;
  text-align: center;
`;

const StyledAppStoreLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  border-radius: 999px;
  background: rgba(255, 255, 255, .06);
  color: #f0ece5;
  font-family: Roboto-Regular;
  font-size: 13px;
  letter-spacing: .08em;
  line-height: 1;
  text-transform: uppercase;
  transition: background 180ms ease;

  &:hover {
    background: rgba(150, 185, 75, .16);
  }

  svg {
    width: 24px;
    height: 24px;
    flex: 0 0 auto;
  }
`;

const StyledApplication = styled.a`
  position: relative;
  width: min(100%, 488px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: clamp(24px, 4vw, 38px);
  border: 1px solid rgba(220, 226, 230, .1);
  border-radius: 22px;
  background: rgba(5, 12, 20, .22);
  text-decoration: none;
  text-align: center;
  transition: transform 180ms ease, border-color 180ms ease, background 180ms ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(150, 185, 75, .45);
    background: rgba(150, 185, 75, .07);
  }
`;

const StyledApplicationImage = styled(Image)`
  width: 76px;
  height: 76px;
  border-radius: 18px;
`;

const StyledApplicationTitle = styled.strong`
  color: #f0ece5;
  font-family: Roboto-Black;
  font-size: clamp(18px, 2vw, 23px);
`;

const StyledApplicationDescription = styled.span`
  max-width: 430px;
  color: #b8c1c7;
  font-family: Roboto-Light;
  font-size: 16px;
  line-height: 1.55;
`;

const StyledArrow = styled(BsArrowUpRight)`
  position: absolute;
  top: 20px;
  right: 22px;
  width: 30px;
  height: 30px;
  color: #96b94b !important;
  transition: transform 180ms ease;

  ${StyledApplication}:hover & {
    transform: translate(2px, -2px);
  }

  @media (max-width: 420px) {
    top: 16px;
    right: 17px;
    width: 25px;
    height: 25px;
  }
`;

export const Apps = () => (
  <StyledApps id="apps">
    <StyledHeader>Our apps</StyledHeader>
    <StyledIntro>
      <span>Products designed and built by <BrandName />.</span>
      <StyledAppStoreLink
        href="https://apps.apple.com/us/developer/essencebit-srl/id1742028270"
        target="_blank"
        rel="noreferrer"
      >
        <FaAppStoreIos aria-hidden="true" /> View on App Store
      </StyledAppStoreLink>
    </StyledIntro>
    <StyledApplication href="https://apps.apple.com/us/app/reminder-bro/id6501989574" target="_blank" rel="noreferrer">
      <StyledApplicationImage src={reminderbroImage} alt="Reminder Bro" />
      <StyledApplicationTitle>Reminder Bro</StyledApplicationTitle>
      <StyledApplicationDescription>
        An iOS app for organizing events and receiving reminders exactly when they matter.
      </StyledApplicationDescription>
      <StyledArrow aria-hidden="true" focusable="false" />
    </StyledApplication>
  </StyledApps>
);
